import { DocumentTrackingEventType } from 'client/utils/datadog';

export const ConditionalJobOfferTrackingEvents: Record<DocumentTrackingEventType, string> = {
    signCheckboxClicked: 'cjo_task.sign_checkbox.clicked',
    submitBtnClicked: 'cjo_task.submit_btn.clicked',
    backBtnClicked: 'cjo_task.back_btn.clicked',
    downloadDocumentClicked: 'cjo_task.download_document_btn.clicked',
    completeTrainingClicked: 'cjo_task.complete_training_btn.clicked',
} as const;
